module.exports = __webpack_public_path__ + "img/img_onboarding_success.4eab6efd.svg";